export default __webpack_public_path__ + "static/Litepaper - Arabic-56fb0bae76f3383fe0a49cfb9c249bcf.pdf";